import { ArrowUp, Download, ExternalLink, Mail, Phone } from "lucide-react";
import { ContactButton } from "../components/ContactButton";
import { CopyContactButton } from "../components/CopyContactButton";
import { FadeIn } from "../components/FadeIn";
import {
  profile,
  publicContactUrl,
  publicEmail,
  publicPhone,
  resumeDownloadName,
  resumeHref,
} from "../content/portfolio";

export function ContactSection() {
  const contactHref = publicContactUrl || (publicEmail ? `mailto:${publicEmail}` : null);

  return (
    <section id="contact" aria-labelledby="contact-heading" className="contact-section">
      <div className="contact-grid" aria-hidden="true" />
      <div className="contact-heading-row">
        <FadeIn as="h2" id="contact-heading" y={34} className="section-heading section-heading--dark">
          一起把质量<br />接到发布上。
        </FadeIn>
      </div>
      <div className="contact-content">
        <FadeIn as="p" delay={0.1} className="contact-copy">
          如果你正在寻找测试开发、质量效能或 AI 测试工具开发方向的合作，欢迎通过公开渠道联系我。
        </FadeIn>
        <FadeIn delay={0.16} className="contact-actions">
          {contactHref && <ContactButton href={contactHref}>联系我</ContactButton>}
          <a className="resume-button" href={resumeHref} download={resumeDownloadName}>
            <Download className="h-4 w-4" aria-hidden="true" />
            下载简历
          </a>
        </FadeIn>
        <FadeIn delay={0.22} className="contact-details">
          <div className="contact-detail-row">
            <Phone aria-hidden="true" />
            <a
              className="contact-detail-link"
              href={`tel:${publicPhone.replace(/[^+\d]/g, "")}`}
            >
              {publicPhone}
            </a>
            <CopyContactButton
              value={publicPhone}
              label="电话号码"
              testId="contact-phone-copy"
            />
          </div>
          <div className="contact-detail-row">
            <Mail aria-hidden="true" />
            <a className="contact-detail-link" href={`mailto:${publicEmail}`}>
              {publicEmail}
            </a>
            <CopyContactButton
              value={publicEmail}
              label="邮箱地址"
              testId="contact-email-copy"
            />
          </div>
          {publicContactUrl && (
            <a href={publicContactUrl} target="_blank" rel="noreferrer">
              公开联系页 <ExternalLink aria-hidden="true" />
            </a>
          )}
        </FadeIn>
      </div>
      <footer className="contact-footer">
        <span>{profile.name} · {profile.role}</span>
        <span>© {new Date().getFullYear()} / QUALITY SYSTEMS</span>
        <a href="#hero" aria-label="返回顶部">
          <ArrowUp aria-hidden="true" />
        </a>
      </footer>
    </section>
  );
}
